module.exports = __webpack_public_path__ + "img/bilaterale_dx.6a466459.png";